/**
 * @file Contributors related constants.
 */

/**
 * Contributor permission types.
 *
 * @enum PERMISSION_TYPES
 * @type {{UPLOAD_ACCESS: string, VIEW_ACCESS: string}}
 */
const PERMISSION_TYPES = {
  UPLOAD_ACCESS: 'upload_access',
  VIEW_ACCESS: 'view_access',
  ALBUM_CREATE_ACCESS: 'album_create_access',
};

/**
 * Default no-permission.
 */
const PERMISSION_NONE = 'NONE';

/**
 * Contributor view access enum.
 *
 * @enum CONTRIBUTOR_VIEW_ACCESS
 * @type {{NONE: string, ALL: string}}
 */
const CONTRIBUTOR_VIEW_ACCESS = {
  NONE: 'NONE',
  ALL: 'ALL',
  OWN: 'OWN',
};

/**
 * Contributor upload access enum.
 *
 * @enum CONTRIBUTOR_UPLOAD_ACCESS
 * @type {{REVIEW: string, PUBLISH: string, NONE: string}}
 */
const CONTRIBUTOR_UPLOAD_ACCESS = {
  NONE: 'NONE',
  PUBLISH: 'PUBLISH',
  REVIEW: 'REVIEW',
};

const CONTRIBUTOR_PERMISSION_CHECK_TYPE = {
  ANY: 'ANY', // At least 1 permission is met
  ALL: 'ALL', // All permissions must be met
  /**
   * Default allow-no-access-to-contributor permission.
   * As we build out permissions, it might not make sense to have this, but it serves
   * as a nice placeholder in the meantime.
   */
  NO_CONTRIBUTOR: 'NO_CONTRIBUTOR',
};

const CONTRIBUTOR_FOLDER_VIEWS = {
  HOME: 'HOME',
  SHARED: 'SHARED',
};

/**
 * Contributor album create access enum.
 *
 * @enum CONTRIBUTOR_ALBUM_CREATE_ACCESS
 * @type {{CREATE: string, NONE: string}}
 */
const CONTRIBUTOR_ALBUM_CREATE_ACCESS = {
  NONE: 'NONE',
  CREATE: 'CREATE',
};

/**
 * Contributor selfie station access enum.
 *
 * @enum CONTRIBUTOR_SELFIE_STATION_ACCESS
 * @type {{MANAGE: string, NONE: string}}
 */
const CONTRIBUTOR_SELFIE_STATION_ACCESS = {
  NONE: 'NONE',
  MANAGE: 'MANAGE',
};

export {
  PERMISSION_TYPES,
  CONTRIBUTOR_UPLOAD_ACCESS,
  CONTRIBUTOR_VIEW_ACCESS,
  PERMISSION_NONE,
  CONTRIBUTOR_PERMISSION_CHECK_TYPE,
  CONTRIBUTOR_FOLDER_VIEWS,
  CONTRIBUTOR_ALBUM_CREATE_ACCESS,
  CONTRIBUTOR_SELFIE_STATION_ACCESS,
};
